import { AlertTriangle } from 'lucide-react';
import { Button, EmptyState } from '@/shared/ui';

// A failed load must not look like "nothing here yet" — that reads as "you
// have no agents/sources" and invites setting them up again.
export function LoadError({
  title,
  onRetry,
  isRetrying,
}: {
  title: string;
  onRetry: () => void;
  isRetrying?: boolean;
}) {
  return (
    <EmptyState
      icon={<AlertTriangle size={22} />}
      title={title}
      description="This didn't load — nothing has changed on your account. Try again in a moment."
      actions={
        <Button variant="secondary" size="sm" onClick={onRetry} loading={isRetrying}>
          Try again
        </Button>
      }
    />
  );
}
